/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMerchantProjectURL, getMerchantCurrenciesURL } from '../../endpoints';
import axiosInstance from '../../helpers/axiosInstance';
import Currency from '../../interfaces/Currency';
import MerchantProject from '../../interfaces/MerchantProject';

export const fetchProject = createAsyncThunk(
	'PUBLICFORM/FETCH_PROJECT',
	(id: string, { rejectWithValue }) => {
		return axiosInstance
			.get<MerchantProject>(getMerchantProjectURL(id))
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);

export const fetchCurrencies = createAsyncThunk(
	'PUBLICFORM/FETCH_CURRENCIES',
	(_, { rejectWithValue }) => {
		return axiosInstance
			.get<Currency[]>(getMerchantCurrenciesURL())
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);
